import { PbstckBidderGlobalConfig, UpsertPbstckBidderGlobalConfig } from '@pubstack/common/src/pbstckBidderGlobalConfig'
import { MutationToasts, useMutation, useQuery } from '../api-client'

const URL = '/admin/pbstck-bidder-global-config'
const PBSTCK_BIDDER_GLOBAL_CONFIG_KEYS = ['pbstck-bidder-global-config']

//-------------------------------------------------------------------------
// Queries
//-------------------------------------------------------------------------
/** `enabled` because this is an `/admin` URL: it 403s for anyone but a Pubstack user, so callers that
 * render for customers too have to hold the request back rather than let it fail in the background. */
export const usePbstckBidderGlobalConfig = (enabled = true) => {
  return useQuery<PbstckBidderGlobalConfig>({
    url: URL,
    keys: PBSTCK_BIDDER_GLOBAL_CONFIG_KEYS,
    enabled,
  })
}

//-------------------------------------------------------------------------
// Mutations
//-------------------------------------------------------------------------
export const useUpdatePbstckBidderGlobalConfig = (toasts: MutationToasts = {}) => {
  return useMutation<UpsertPbstckBidderGlobalConfig>({
    method: 'put',
    url: URL,
    collectionKeys: PBSTCK_BIDDER_GLOBAL_CONFIG_KEYS,
    ...toasts,
  })
}
